import React, { useEffect, useState } from "react";
import { Card, Row, Col, Dropdown, DropdownButton } from "react-bootstrap";
import {
  getCurrencies,
  updateCurrency,
  getSettings,
  updateNotificationStatus,
  updateUserRole,
  switchTheme,
  userSetting
} from "../../actions/setting-action";
import { connect, useDispatch, useSelector } from "react-redux";
import { minimalTimezoneSet } from "compact-timezone-list";
import Switch from "react-switch";
import { UserRole,Themes, LanguageName } from "../../Const";
import { toast } from "react-toastify";
import "./GeneralPanel.scss";
import { useTranslation } from "react-i18next";
import { APP_LANGUAGE } from "../../actions/types";
import Cookies from "universal-cookie";

const GeneralPanel = (props) => {
  const {
    getCurrencies,
    updateCurrency,
    getSettings,
    updateNotificationStatus,
    updateUserRole,
    switchTheme
  } = props;
  const {t} = useTranslation()
  const dispatch = useDispatch();
  const cookies = new Cookies();

  const currencies = useSelector((state) => state.settings.currencies);
  const currency = useSelector((state) => state.settings.currency);
  const language = useSelector((state) => state.settings.currentLang);
  console.log(language)
  const theme = useSelector((state) => state.settings.selected_theme);
  const themeChecked = '/images/icons/check.png'
  const userRole =
    useSelector((state) => state.settings.userRole) || UserRole.normal;

  const [isOn, setIsOn] = useState(false);

  const notificationStatus = useSelector(
    (state) => state.settings.bot_notification_enabled
  );

  useEffect(() => {
    getSettings();
  }, []);

  useEffect(() => {
    if (notificationStatus != null) {
      setIsOn(notificationStatus == 1);
    }
  }, [notificationStatus]);

  const changeNotification = (isOn) => {
    setIsOn(isOn);
    updateNotificationStatus(isOn ? 1 : 0);
  };
  const changeLanguage = (lang)=>{
    console.log(lang)
    dispatch({
        type:APP_LANGUAGE,
        payload:lang
    })
    cookies.set('current_lang', lang, { path: '/',maxAge:60 * 60 * 24 * 365 * 10 });
    dispatch(userSetting("language",lang));
    setTimeout(() => {
      window.location.reload()
    }, 2000);
    
}

  useEffect(() => {
    getCurrencies();
  }, []);

  const changeUserRole = (isOn) => {
    updateUserRole(isOn ? UserRole.beta : UserRole.normal)
      .then(() => {})
      .catch((err) => toast.error(err));
  };

  const currencyItems = currencies.map((item) => {
    return (
      <Dropdown.Item key={item.id} eventKey={item.id}>
        {item.name}
      </Dropdown.Item>
    );
  });
  const themeItems = Object.keys(Themes).map((item, index) => {
    return (
      <div key={index} className={`color-switch theme-${item}`} onClick={() => switchTheme(item)}>
        {theme==item && (<img src={themeChecked}></img>)}
      </div>
    );
  });

  const timezone = localStorage.getItem("timezone");
  const [offset, setOffset] = useState(timezone || "+00:00");
  const currentZone =
    minimalTimezoneSet.find((item) => item.offset === offset) ||
    minimalTimezoneSet[0];

  const selectTimezone = (timezone) => {
    setOffset(timezone);
    localStorage.setItem("timezone", timezone);
  };

  const timezoneItems = minimalTimezoneSet.map((item, index) => {
    return (
      <Dropdown.Item key={index} eventKey={item.offset}>
        {item.label}
      </Dropdown.Item>
    );
  });
  const languageItems = Object.keys(LanguageName).map(function(key, index) {
    return (
      <Dropdown.Item key={index} eventKey={key}>
        {LanguageName[key]}
      </Dropdown.Item>
    );
  });

  return (
    <>
      <div className="round-bg general-panel">
        <br />
        <Row className="setting-row">
          <Col xs={3} xl={6}>
            <h5>{t("theme")}</h5>
            <br/>
          </Col>
          <Col xs={9} xl={6} className="text-center">
            {/* <div className="color-switch theme-light">
              {theme=='light' && (<img src={themeChecked}></img>)}
            </div>
            <div className="color-switch theme-dark">
            {theme=='dark' && (<img src={themeChecked}></img>)}
            </div>
            <div className="color-switch theme-pink">
            {theme=='pink' && (<img src={themeChecked}></img>)}
            </div>
            <div className="color-switch theme-purple">
            {theme=='purple' && (<img src={themeChecked}></img>)}
            </div>
            <div className="color-switch theme-blue">
            {theme=='blue' && (<img src={themeChecked}></img>)}
            </div> */}
            {themeItems}
          </Col>
        </Row>
        <hr />
        <br />
        <br />
        <Row className="setting-row">
          <Col xs={9} xl={10}>
            <h5>{t("ch-beta")}</h5>
            <p>
              {t("beta-prog")}
            </p>
          </Col>
          <Col xs={3} xl={2} className="text-center">
            <Switch
              checkedIcon={false}
              uncheckedIcon={false}
              checked={userRole !== UserRole.normal}
              onChange={changeUserRole}
              onColor="#05CD99"
            />
          </Col>
        </Row>
        <hr />
        <br />
        <Row className="setting-row">
          <Col xs={9} xl={10}>
            <h5 style={{ marginTop: 5 }}>{t("native-curr")}</h5>
          </Col>
          <Col xs={3} xl={2} className="text-center">
            <DropdownButton
              title={(currency && currency.name) || ""}
              onSelect={(e) => updateCurrency(Number(e))}
              variant="outline-secondary"
            >
              {currencyItems}
            </DropdownButton>
          </Col>
        </Row>
        <br />
        <hr />
        <br />
        <Row className="timezone setting-row">
          <Col xs={7}>
            <h5 style={{ marginTop: 5 }}>{t("timezone")}</h5>
          </Col>
          <Col xs={5} className="text-right">
            <DropdownButton
              variant="outline-secondary"
              title={
                timezone
                  ? currentZone.label
                  : Intl.DateTimeFormat().resolvedOptions().timeZone
              }
              onSelect={selectTimezone}
            >
              {timezoneItems}
            </DropdownButton>
          </Col>
        </Row>
        <br />
        <hr />
        <br />
        <Row className="setting-row">
        <Col xs={7}>
            <h5 style={{ marginTop: 5 }}>{t("language")}</h5>
          </Col>
          <Col xs={5} className="text-right">
            <DropdownButton
              variant="outline-secondary"
              title={
                LanguageName[language]
              }
              onSelect={changeLanguage}
            >
              {languageItems}
            </DropdownButton>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default connect(null, {
  getCurrencies,
  updateCurrency,
  getSettings,
  updateNotificationStatus,
  updateUserRole,
  switchTheme
})(GeneralPanel);
